var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcBenefits(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 30.75C29.2792 30.75 31.9375 28.0917 31.9375 24.8125C31.9375 21.5333 29.2792 18.875 26 18.875C22.7208 18.875 20.0625 21.5333 20.0625 24.8125C20.0625 28.0917 22.7208 30.75 26 30.75Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4707 36.5984C17.3642 34.8386 18.7275 33.3605 20.4096 32.3281C22.0916 31.2956 24.0267 30.7491 26.0004 30.7491C27.974 30.7491 29.9092 31.2956 31.5912 32.3281C33.2733 33.3605 34.6366 34.8386 35.5301 36.5984",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.125 15.3125H40.25",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6875 11.75V18.875",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0719 23.7586C40.1919 24.4997 40.2515 25.2493 40.25 26C40.25 28.8184 39.4143 31.5735 37.8484 33.9169C36.2826 36.2603 34.0571 38.0867 31.4532 39.1653C28.8494 40.2438 25.9842 40.526 23.22 39.9762C20.4557 39.4263 17.9166 38.0692 15.9237 36.0763C13.9308 34.0834 12.5737 31.5443 12.0238 28.78C11.474 26.0158 11.7562 23.1506 12.8347 20.5468C13.9133 17.9429 15.7397 15.7174 18.0831 14.1516C20.4265 12.5857 23.1816 11.75 26 11.75C26.7507 11.7485 27.5003 11.8081 28.2414 11.9281",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBenefits);
export default __webpack_public_path__ + "static/media/ic_benefits.f2ce632f85dbd42f634e494cf9611775.svg";
export { ForwardRef as ReactComponent };